import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=578dcc2c&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=ts"
export * from "./Orders.vue?vue&type=script&lang=ts"
import style0 from "./Orders.vue?vue&type=style&index=0&id=578dcc2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578dcc2c",
  null
  
)

export default component.exports